/**
 * VB New - Preguntas frecuentes
 * Escritorio: acordeón, abre una respuesta a la vez.
 * Móvil: todas las respuestas visibles (diseño de Figma), sin acordeón.
 */
(function () {
  'use strict';

  var mobileQuery = window.matchMedia('(max-width: 768px)');

  function setOpen(toggle, open) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  function init(root) {
    if (!root || root.dataset.vbnReady) return;
    root.dataset.vbnReady = 'true';

    var toggles = root.querySelectorAll('[data-vbn-faq-toggle]');

    function applyLayout() {
      toggles.forEach(function (toggle) {
        setOpen(toggle, mobileQuery.matches);
        if (mobileQuery.matches) {
          toggle.setAttribute('aria-disabled', 'true');
        } else {
          toggle.removeAttribute('aria-disabled');
        }
      });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (mobileQuery.matches) return;
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggles.forEach(function (other) {
          if (other !== toggle) setOpen(other, false);
        });
        setOpen(toggle, open);
      });
    });

    applyLayout();
    mobileQuery.addEventListener('change', applyLayout);

    console.log('[VBN FAQs] Inicializado con', toggles.length, 'preguntas');
  }

  function initAll() {
    document.querySelectorAll('[data-vbn-faqs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-vbn-faqs]'));
  });

  // Theme editor: abrir la pregunta seleccionada
  document.addEventListener('shopify:block:select', function (event) {
    var toggle = event.target.querySelector('[data-vbn-faq-toggle]');
    if (toggle) setOpen(toggle, true);
  });
})();
